Greenmile.Survey = Greenmile.Survey || {};

Greenmile.Survey.Data = {
    surveyData: [],
    surveyActions: [],

    clearSurveyData: function () {
        this.surveyData = [];
        this.surveyActions = [];
    },

    getAllQuestions: function (parentQuestionId) {
        var sections = Greenmile.Survey.Data.surveyData;
        var questions = [];
        for (var i in sections) {
            questions = questions.concat(this.getQuestionsBySection(sections[i], parentQuestionId).questions);
        }

        return questions;
    },

    getQuestionsBySection: function (section, parentQuestionId) {

        var questions = section.surveyQuestions.slice(0);
        var questionsToReturn = [];

        var isParentQuestion = function (questions) {
            return !parentQuestionId && !questions.parentQuestionId;
        };

        var isSubQuestion = function (question) {
            return parentQuestionId && parentQuestionId === question.parentQuestionId;
        };

        if (questions) {
            for (var i in questions) {
                if (isParentQuestion(questions[i])) {
                    questionsToReturn.push(questions[i]);
                } else if (isSubQuestion(questions[i])) {
                    questionsToReturn.push(questions[i]);
                }
            }

            return {

                sectionID: section.id,
                questions: questionsToReturn

            };

        }
    },

    addSurveySection: function (section) {

        this.surveyData.push(section);
    },

    addQuestionToSection: function (sectionID, question, parentQuestionId) {
        var section,
            sections          = this.surveyData,
            sectionQuestions,
            i, sectionsLength = sections.length,
            sectionQuestion,
            questionsOrder;

        for (i = 0; i < sectionsLength; i++) {
            if (sections[i].id.toString() === sectionID.toString()) {
                section = sections[i];
                sectionQuestions = section.surveyQuestions;
                if (parentQuestionId) {
                    for (var j in sectionQuestions) {
                        sectionQuestion = sectionQuestions[j];
                        if (sectionQuestion.id === parentQuestionId) {
                            sectionQuestion.subQuestions = sectionQuestion.subQuestions || [];
                            sectionQuestion.subQuestions.push({ key: question.key });
                            questionsOrder = sectionQuestion.subQuestions.length;
                            break;
                        }
                    }

                    question.parentQuestionId = parentQuestionId;
                }

                sectionQuestions.push(question);

                question.order = questionsOrder || sectionQuestions.length;
            }
        }
    },

    findSection: function (sectionID) {

        var sectionIndex,
            i;

        for (i = 0; i < this.surveyData.length; i++) {

            if (this.surveyData[i].id.toString() === sectionID.toString()) {

                sectionIndex = i;
                break;

            }

        }

        return this.surveyData[sectionIndex];

    },

    findQuestion: function (questionID) {
        var i,
            j,
            question = null,
            questions;

        if (questionID) {

            for (i = 0; i < this.surveyData.length; i++) {

                questions = this.surveyData[i].surveyQuestions;

                for (j = 0; j < questions.length; j++) {

                    if (questions[j].id.toString() === questionID.toString()) {

                        question = questions[j];
                        break;
                    }
                }
            }

        }

        return question;
    },

    findQuestionDomain: function (question, answerID) {

        var index;

        for (var i = 0; i < question.surveyQuestionDomain.length; i++) {

            var questionDomain = question.surveyQuestionDomain[i];

            if (questionDomain.id && answerID.toString() === questionDomain.id.toString()) {

                index = i;
                break;

            }

        }

        return question.surveyQuestionDomain[index];

    },

    findAnswerByValue: function (questionDomain, answerValue) {

        var index;

        for (var i = 0; i < questionDomain.length; i++) {

            var domain = questionDomain[i];

            if (answerValue.toString() === domain.value.toString()) {

                index = i;
                break;

            }

        }

        return questionDomain[index];

    },

    removeQuestionDomain: function (question, answer) {

        var index;

        for (var i = 0; i < question.surveyQuestionDomain.length; i++) {

            var questionDomain = question.surveyQuestionDomain[i];

            if (answer.id.toString() === questionDomain.id.toString()) {

                index = i;
                break;

            }

        }

        if (typeof index !== 'undefined') {

            question.surveyQuestionDomain.splice(index, 1);

        }

    },

    getQuestionById: function (id, questions) {
        if (!questions) {
            questions = this.getAllQuestions();
        }
        for (var j = 0, sizeQuestions = questions.length; j < sizeQuestions; j++) {

            if (id === questions[j].id) {
                return {
                    question: questions[j],
                    index: j
                };
            }

        }
    },

    getQuestionByAttribute: function (attribute, value, questions) {
        if (!questions) {
            questions = this.getAllQuestions();
        }
        for (var j = 0, sizeQuestions = questions.length; j < sizeQuestions; j++) {

            if (value === questions[j][attribute]) {
                return {
                    question: questions[j],
                    index: j
                };
            }

        }
    },
    getSectionForQuestion: function (questionID) {

        var i,
            j,
            sectionIndex,
            questions;

        for (i = 0; i < this.surveyData.length; i++) {

            questions = this.surveyData[i].surveyQuestions;

            for (j = 0; j < questions.length; j++) {

                if (questions[j].id.toString() === questionID.toString()) {

                    sectionIndex = i;
                    break;

                }

            }

        }

        return this.surveyData[sectionIndex];

    },

    updateQuestion: function (updateQuestion) {

        var i,
            j,
            sectionIndex,
            questionIndex,
            questions;

        for (i = 0; i < this.surveyData.length; i++) {

            questions = this.surveyData[i].surveyQuestions;

            for (j = 0; j < questions.length; j++) {

                if (questions[j].id.toString() === updateQuestion.id.toString()) {

                    sectionIndex = i;
                    questionIndex = j;
                    break;
                }
            }
        }

        this.surveyData[sectionIndex].surveyQuestions.splice(questionIndex, 1, updateQuestion);
    },

    itemAlreadyExists: function (questionId, newItemValue) {

        var sectionsSurvey = Greenmile.Survey.Data.surveyData;
        var itemAlreadyExists = false;

        for (var i in sectionsSurvey) {

            var questions = sectionsSurvey[i].surveyQuestions;

            for (var j in questions) {

                if (questions[j].id === questionId) {

                    var questionDomain = questions[j].surveyQuestionDomain;

                    for (var k in questionDomain) {

                        var item = questionDomain[k];

                        if (item.value === newItemValue) {
                            itemAlreadyExists = true;
                            break;
                        }

                    }

                }

            }

        }

        return itemAlreadyExists;

    },

    existNewItem: function () {

        var sectionsSurvey = Greenmile.Survey.Data.surveyData;
        var existNewItem = false;

        for (var i in sectionsSurvey) {

            var questions = sectionsSurvey[i].surveyQuestions;

            for (var j in questions) {

                var questionDomain = questions[j].surveyQuestionDomain;

                for (var k in questionDomain) {

                    var item = questionDomain[k];

                    if (item.isNew) {
                        existNewItem = true;
                        break;
                    }

                }

            }

        }

        return existNewItem;

    },

    getSurveyActions: function () {
        return this.surveyActions;
    },

    setSurveyActions: function () {
        const questions = this.getAllQuestions();
        questions.forEach((question) => {
            if (question.generateTask) {
                const eventType = 'GENERATE_TASK';
                if (question.jsonParameter) {
                    const taskType = question.jsonParameter.type;
                    const criteria = question.jsonParameter.criteria;
                    const surveyAction = taskType && (this.getSurveyActionByTaskTypeId(taskType.id) || this.addSurveyAction({ taskType, eventType }));
                    if (surveyAction && criteria) {
                        this.addSurveyActionCondition(surveyAction.id, question.id, criteria);
                    }

                }
            }
        });
    },

    isSurveyQuestionAllowed: function (questionId, fieldValue) {
        return !this.surveyActions.some((surveyAction) => (
            surveyAction.conditions.some((condition) => condition.questionId === questionId && questionId !== parseInt(fieldValue)))
        );
    },

    getSurveyActionTaskTypeCriteriaChain: function () {
        return this.surveyActions.reduce((result, surveyAction) => {
            const id = surveyAction.taskType?.id;
            return id ? [...result, { attr: 'id', neq: id }] : result;
        }, []);
    },

    addSurveyAction: function (action = {}) {
        const id = uuid.v1();
        const length = this.surveyActions.push({
            id,
            taskType: action.taskType || {},
            eventType: action.eventType || '',
            conditions: []
        });
        return this.surveyActions[length - 1];
    },

    updateSurveyAction: function (actionId, data) {
        const index = this.surveyActions.findIndex((surveyAction) => surveyAction.id === actionId);
        if (index >= 0) {
            this.surveyActions[index] = { ...this.surveyActions[index], ...data };
        }
    },

    removeSurveyActionById: function (actionId) {
        this.surveyActions = this.surveyActions.filter((surveyAction) => surveyAction.id !== actionId);
    },

    getSurveyActionById: function (actionId) {
        return this.surveyActions.find((surveyAction) => surveyAction.id === actionId);
    },

    getSurveyActionOrderById: function (actionId) {
        const index = this.surveyActions.findIndex((surveyAction) => surveyAction.id === actionId);
        return (index >= 0) ? `${index + 1}` : '';
    },

    getSurveyActionByTaskTypeId: function (taskTypeId) {
        return this.surveyActions.find((surveyAction) => surveyAction.taskType.id === taskTypeId);
    },

    getSurveyQuestionActionAttributes: function (questionId) {
        const attributes = { generateTask: false, jsonParameter: {} };
        this.surveyActions.forEach((surveyAction) => {
            const criteria = surveyAction.conditions.find((condition) => condition.questionId === questionId)?.criteria;
            if (criteria) {
                attributes.generateTask = surveyAction.eventType === 'GENERATE_TASK';
                attributes.jsonParameter = { type: surveyAction.taskType, criteria };
                return;
            }
        });
        return attributes;
    },

    addSurveyActionCondition: function (actionId, questionId = null, criteria = []) {
        const id = uuid.v1();
        const surveyAction = this.getSurveyActionById(actionId);
        surveyAction?.conditions.push({ id, questionId, criteria });
        return id;
    },

    removeSurveyActionCondition: function (actionId, conditionId) {
        const surveyAction = this.getSurveyActionById(actionId);

        if (surveyAction) {
            surveyAction.conditions = surveyAction.conditions.filter((condition) => condition.id !== conditionId);
        };
    },

    updateSurveyActionCondition: function (actionId, conditionId, data) {
        const surveyAction = this.getSurveyActionById(actionId);
        const conditionIndex = surveyAction.conditions.findIndex((condition) => condition.id === conditionId)

        if (conditionIndex >= 0) {
            surveyAction.conditions[conditionIndex] = { ...surveyAction.conditions[conditionIndex], ...data };
        }
    },

    findOrganizationDescendants: function (nodes, targetId) {
        for (const node of nodes) {
            if (node.id === targetId) {
                return [node.id, ...this.getAllChildrenOrganization(node)];
            }
    
            if (node.children) {
                const result = this.findOrganizationDescendants(node.children, targetId);
                if (result.length) return result;
            }
        }
        return [];
    },
    
    getAllChildrenOrganization: function (node) {
        let childDescendants = [];
        if (node.children) {
            for (const child of node.children) {
                childDescendants.push(child.id);
                childDescendants = childDescendants.concat(this.getAllChildrenOrganization(child));
            }
        }
        return childDescendants;
    },
    
    formatToTreeViewData: function (data) {
        function formatOrganization(org, childrenOrgs = []) {
            return {
                id: org.id,
                name: org.description,
                children: childrenOrgs.map(child => formatOrganization(child.organization, child.childOrganizations || []))
            };
        }
        return data.map(item => formatOrganization(item.organization, item.childOrganizations || []));
    }
};
